module.exports = __webpack_public_path__ + "media/images/checkout-table-header-background-3f7d2efc8159093fff9ad21769451d6c.png";